import { useAppSelector } from '@store/index'
import { selectAllApartments, selectReservation } from '@store/selectors/reservation-selectors'
import { Apartment } from '@models/reservation'
import { isForClientWithBenefit } from '@modules/accommodation-selection-step/local-selection/local-selection-map/use-clickable-resort-map'

interface Response {
  selectedApartment: Apartment | undefined
  isSpecialLocalSelected: boolean
}

export const useReservationApartment = (): Response => {
  const apartments = useAppSelector(selectAllApartments)
  const { selected_apartment_id, apartment_id } = useAppSelector(selectReservation)

  const selectedApartment = apartments.find(apartment => apartment.id === (selected_apartment_id || apartment_id))

  return {
    selectedApartment,
    isSpecialLocalSelected: selectedApartment ? isForClientWithBenefit(selectedApartment) : false,
  }
}
